// ./context/instructor/instructorReducer.js

const instructorReducer = (state, { type, payload }) => {
    switch (type) {
        case 'LOAD_INSTRUCTORS':
        case 'SET_INSTRUCTOR_DATA':
            return {
                ...state,
                instructorData: payload,
                isLoading: false,
                error: null
            };

        case 'UPDATE_INSTRUCTOR_PROFILE':
            return {
                ...state,
                instructorData: {
                    ...state.instructorData,
                    ...payload
                },
                isLoading: false,
                error: null
            };

        case 'SET_ASSIGNED_COURSES':
            return {
                ...state,
                assignedCourses: payload,
                isLoading: false,
                error: null
            };

        case 'ADD_ASSIGNED_COURSE':
            return {
                ...state,
                assignedCourses: [...state.assignedCourses, payload],
                isLoading: false,
                error: null
            };

        case 'REMOVE_ASSIGNED_COURSE':
            return {
                ...state,
                assignedCourses: state.assignedCourses.filter(
                    course => course.courseId !== payload
                ),
                isLoading: false,
                error: null
            };

        case 'UPDATE_ASSIGNED_COURSE':
            return {
                ...state,
                assignedCourses: state.assignedCourses.map(course =>
                    course.courseId === payload.courseId
                        ? { ...course, ...payload }
                        : course
                ),
                isLoading: false,
                error: null
            };

        case 'SET_COURSE_STUDENTS':
            return {
                ...state,
                courseStudents: payload,
                isLoading: false,
                error: null
            };

        case 'SET_GRADED_LABS':
        case 'SET_PENDING_LABS':
            return {
                ...state,
                pendingLabs: payload,
                isLoading: false,
                error: null
            };

        case 'SET_PENDING_QUIZZES':
            return {
                ...state,
                pendingQuizzes: payload,
                isLoading: false,
                error: null
            };

        case 'SET_PENDING_EXAMS':
            return {
                ...state,
                pendingExams: payload,
                isLoading: false,
                error: null
            };

        case 'SET_PENDING_CAPSTONES':
            return {
                ...state,
                pendingCapstones: payload,
                isLoading: false,
                error: null
            };

        case 'SET_COURSE_LABS':
            return {
                ...state,
                courseLabs: payload,
                isLoading: false,
                error: null
            };

        case 'SET_COURSE_QUIZZES':
            return {
                ...state,
                courseQuizzes: payload,
                isLoading: false,
                error: null
            };

        case 'SET_COURSE_EXAMS':
            return {
                ...state,
                courseExams: payload,
                isLoading: false,
                error: null
            };

        case 'SET_COURSE_CAPSTONES':
            return {
                ...state,
                courseCapstones: payload,
                isLoading: false,
                error: null
            };

        case 'SET_GENERATED_RUBRIC':
            return {
                ...state,
                generatedRubric: payload,
                isRubricGenerating: false,
                error: null
            };

        case 'CLEAR_GENERATED_RUBRIC':
            return {
                ...state,
                generatedRubric: null,
                rubricError: null
            };

        case 'SET_RUBRIC_LOADING':
            return {
                ...state,
                isRubricGenerating: payload,
                rubricError: null
            };

        case 'SET_RUBRIC_ERROR':
            return {
                ...state,
                isRubricGenerating: false,
                rubricError: payload,
                generatedRubric: null
            };

        case 'GRADE_LAB':
            return {
                ...state,
                pendingLabs: state.pendingLabs.filter(
                    lab => !(lab.studentLoginId === payload.studentLoginId && 
                             lab.labId === payload.labId)
                ),
                isLoading: false,
                error: null
            };

        case 'GRADE_QUIZ':
            return {
                ...state,
                pendingQuizzes: state.pendingQuizzes.filter(
                    quiz => !(quiz.studentLoginId === payload.studentLoginId && 
                              quiz.quizId === payload.quizId)
                ),
                isLoading: false,
                error: null
            };

        case 'GRADE_EXAM':
            return {
                ...state,
                pendingExams: state.pendingExams.filter(
                    exam => !(exam.studentLoginId === payload.studentLoginId && 
                              exam.examId === payload.examId)
                ),
                isLoading: false,
                error: null
            };

        case 'GRADE_CAPSTONE':
            return {
                ...state,
                pendingCapstones: state.pendingCapstones.filter(
                    capstone => !(capstone.studentLoginId === payload.studentLoginId && 
                                  capstone.capstoneId === payload.capstoneId)
                ),
                isLoading: false,
                error: null
            };

        case 'SET_DASHBOARD_STATS':
            return {
                ...state,
                dashboardStats: payload,
                isLoading: false,
                error: null
            };

        case 'SET_COURSE_ANALYTICS':
            return {
                ...state,
                courseAnalytics: payload,
                isLoading: false,
                error: null
            };

        case 'SET_GRADING_HISTORY':
            return {
                ...state,
                gradingHistory: payload,
                isLoading: false,
                error: null
            };

        case 'ADD_GRADING_HISTORY':
            return {
                ...state,
                gradingHistory: [payload, ...state.gradingHistory],
                isLoading: false,
                error: null
            };

        case 'SET_LOADING':
            return {
                ...state,
                isLoading: payload
            };

        case 'SET_ERROR':
            return {
                ...state,
                error: payload,
                isLoading: false
            };

        case 'CLEAR_INSTRUCTOR_DATA':
            return {
                instructorData: null,
                assignedCourses: [],
                pendingLabs: [],
                pendingQuizzes: [],
                pendingExams: [],
                pendingCapstones: [],
                courseStudents: [],
                courseLabs: [],
                courseQuizzes: [],
                courseExams: [],
                courseCapstones: [],
                dashboardStats: null,
                courseAnalytics: null,
                gradingHistory: [],
                isLoading: false,
                error: null
            };

        default:
            return state;
    }
};

export default instructorReducer;